import { render, staticRenderFns } from "./Lavori.vue?vue&type=template&id=748288bd"
import script from "./Lavori.vue?vue&type=script&lang=js"
export * from "./Lavori.vue?vue&type=script&lang=js"
import style0 from "./Lavori.vue?vue&type=style&index=0&id=748288bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports